import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "page page57"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "content",
  style: {
    "width": "100%",
    "position": "absolute",
    "top": "7%",
    "transform": "translateY(-50%)"
  }
};
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
const _hoisted_10 = ["src"];
const _hoisted_11 = ["src"];
const _hoisted_12 = ["src"];
const _hoisted_13 = ["src"];
const _hoisted_14 = ["src"];
const _hoisted_15 = ["src"];
const _hoisted_16 = ["src"];
const _hoisted_17 = ["src"];
const _hoisted_18 = ["src"];
const _hoisted_19 = ["src"];
const _hoisted_20 = ["src"];
const _hoisted_21 = ["src"];
const _hoisted_22 = ["src"];
const _hoisted_23 = ["src"];
const _hoisted_24 = ["src"];
const _hoisted_25 = ["src"];
const _hoisted_26 = ["src"];
const _hoisted_27 = ["src"];
const _hoisted_28 = ["src"];
const _hoisted_29 = ["src"];
const _hoisted_30 = ["src"];
const _hoisted_31 = ["src"];
import 场景展示 from '@/assets/v2/page5-1/场景展示.webp';
import 返回首页 from '@/assets/v2/page3/返回首页.webp';
import 图 from '@/assets/v2/page5-7/图.webp';
import wenzi1 from '@/assets/v2/page5-7/文字/wenzi1.webp';
import 沐浴区 from '@/assets/v2/page5-7/文字/沐浴区.webp';
import 窄边 from '@/assets/v2/page5-7/文字/窄边.webp';
import 无影美妆灯 from '@/assets/v2/page5-7/文字/无影美妆灯.webp';
import 淋浴区整面踏板 from '@/assets/v2/page5-7/文字/淋浴区整面踏板.webp';
import 尊享星级卫浴 from '@/assets/v2/page5-7/文字/尊享星级卫浴.webp';
import 竖线1 from '@/assets/v2/page5-1/标识线/竖线1.webp';
import 镜柜壁龛 from '@/assets/v2/page5-7/文字/镜柜壁龛.webp';
import youzhexian from '@/assets/v2/page5-7/标识线条/youzhexian.webp';
import 地漏 from '@/assets/v2/page5-7/文字/地漏.webp';
import youzhexian2 from '@/assets/v2/page5-7/标识线条/youzhexian2.webp';
import 马桶上方收纳 from '@/assets/v2/page5-7/文字/马桶上方收纳.webp';
import 椭圆黑 from '@/assets/v2/page5-1/标识线/椭圆黑.webp';
import zuozhexian from '@/assets/v2/page5-7/标识线条/zuozhexian.webp';
import 轻智能壁挂式马桶 from '@/assets/v2/page5-7/文字/轻智能壁挂式马桶.webp';
export default {
  __name: 'Page5-7',
  emits: ['goHome'],
  setup(__props, {
    emit: __emit
  }) {
    // 引入图片
    const emit = __emit;
    const gohome = () => {
      emit('goHome');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("img", {
        src: _unref(场景展示),
        alt: "场景展示",
        class: "场景展示",
        loading: "lazy"
      }, null, 8, _hoisted_2), _createElementVNode("img", {
        src: _unref(返回首页),
        alt: "返回首页",
        class: "gohomeImage",
        onClick: gohome,
        loading: "lazy"
      }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
        src: _unref(wenzi1),
        alt: "wenzi1",
        class: "wenzi1",
        loading: "lazy"
      }, null, 8, _hoisted_5), _createElementVNode("img", {
        src: _unref(竖线1),
        alt: "竖线1",
        class: "竖线1",
        loading: "lazy"
      }, null, 8, _hoisted_6), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑",
        class: "椭圆黑1",
        loading: "lazy"
      }, null, 8, _hoisted_7), _createElementVNode("img", {
        src: _unref(沐浴区),
        alt: "沐浴区",
        class: "沐浴区",
        loading: "lazy"
      }, null, 8, _hoisted_8), _createElementVNode("img", {
        src: _unref(竖线1),
        alt: "竖线1",
        class: "竖线11",
        loading: "lazy"
      }, null, 8, _hoisted_9), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑",
        class: "椭圆黑11",
        loading: "lazy"
      }, null, 8, _hoisted_10), _createElementVNode("img", {
        src: _unref(窄边),
        alt: "窄边",
        class: "窄边",
        loading: "lazy"
      }, null, 8, _hoisted_11), _createElementVNode("img", {
        src: _unref(zuozhexian),
        alt: "zuozhexian",
        class: "zuozhexian",
        loading: "lazy"
      }, null, 8, _hoisted_12), _createElementVNode("img", {
        src: _unref(镜柜壁龛),
        alt: "镜柜壁龛",
        class: "镜柜壁龛",
        loading: "lazy"
      }, null, 8, _hoisted_13), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑",
        class: "椭圆黑2",
        loading: "lazy"
      }, null, 8, _hoisted_14), _createElementVNode("img", {
        src: _unref(轻智能壁挂式马桶),
        alt: "轻智能壁挂式马桶",
        class: "轻智能壁挂式马桶",
        loading: "lazy"
      }, null, 8, _hoisted_15), _createElementVNode("img", {
        src: _unref(竖线1),
        alt: "竖线1",
        class: "竖线12",
        loading: "lazy"
      }, null, 8, _hoisted_16), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑",
        class: "椭圆黑12",
        loading: "lazy"
      }, null, 8, _hoisted_17), _createElementVNode("img", {
        src: _unref(无影美妆灯),
        alt: "无影美妆灯",
        class: "无影美妆灯",
        loading: "lazy"
      }, null, 8, _hoisted_18), _createElementVNode("img", {
        src: _unref(图),
        alt: "图",
        class: "图",
        loading: "lazy"
      }, null, 8, _hoisted_19), _createElementVNode("img", {
        src: _unref(地漏),
        alt: "地漏",
        class: "地漏",
        loading: "lazy"
      }, null, 8, _hoisted_20), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑",
        class: "椭圆黑3",
        loading: "lazy"
      }, null, 8, _hoisted_21), _createElementVNode("img", {
        src: _unref(youzhexian),
        alt: "youzhexian",
        class: "youzhexian",
        loading: "lazy"
      }, null, 8, _hoisted_22), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑",
        class: "椭圆黑5",
        loading: "lazy"
      }, null, 8, _hoisted_23), _createElementVNode("img", {
        src: _unref(竖线1),
        alt: "竖线1",
        class: "竖线5",
        loading: "lazy"
      }, null, 8, _hoisted_24), _createElementVNode("img", {
        src: _unref(淋浴区整面踏板),
        alt: "淋浴区整面踏板",
        class: "淋浴区整面踏板",
        loading: "lazy"
      }, null, 8, _hoisted_25), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑",
        class: "椭圆黑51",
        loading: "lazy"
      }, null, 8, _hoisted_26), _createElementVNode("img", {
        src: _unref(youzhexian2),
        alt: "youzhexian2",
        class: "youzhexian2",
        loading: "lazy"
      }, null, 8, _hoisted_27), _createElementVNode("img", {
        src: _unref(马桶上方收纳),
        alt: "马桶上方收纳",
        class: "马桶上方收纳",
        loading: "lazy"
      }, null, 8, _hoisted_28), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑",
        class: "椭圆黑6",
        loading: "lazy"
      }, null, 8, _hoisted_29), _createElementVNode("img", {
        src: _unref(竖线1),
        alt: "竖线1",
        class: "竖线6",
        loading: "lazy"
      }, null, 8, _hoisted_30), _createElementVNode("img", {
        src: _unref(尊享星级卫浴),
        alt: "尊享星级卫浴",
        class: "尊享星级卫浴",
        loading: "lazy"
      }, null, 8, _hoisted_31)])]);
    };
  }
};